import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {IntelligenceSearchInterface} from '../../../models/intelligence-search.interface';
import {ActivatedRoute} from '@angular/router';
import {setFormValuesFromQueryParams} from '../../../utils/filters-utils';

@Component({
  selector: 'app-weee-treatment-standard-mandatory-filters',
  templateUrl: './weee-treatment-standard-mandatory-filters.component.html',
  styleUrls: ['./weee-treatment-standard-mandatory-filters.component.scss']
})
export class WeeeTreatmentStandardMandatoryFiltersComponent implements OnInit {

  responseType = [
    {value: 'Yes, WEEELABEX', description: 'Yes, WEEELABEX'},
    {value: 'Yes CENELEC', description: 'Yes CENELEC'},
    {value: 'Yes, WEEELABEX and CENELEC', description: 'Yes, WEEELABEX and CENELEC'},
    {value: 'Yes, other standards', description: 'Yes, other standards'},
    {value: 'No', description: 'No'},
  ];

  searchForm = this.formBuilder.group({
    responseType: [''],
  });

  get responseTypeControl(): FormControl {
    return this.searchForm.get('responseType') as FormControl;
  }

  @Output()
  search: EventEmitter<IntelligenceSearchInterface> = new EventEmitter<IntelligenceSearchInterface>();

  constructor(private formBuilder: FormBuilder,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    setFormValuesFromQueryParams(this.searchForm, this.activatedRoute);
  }

  handleSubmit(): void {
    this.search.emit({
      responseType: this.responseTypeControl.value
    } as IntelligenceSearchInterface);
  }

  clean(): void {
    this.responseTypeControl.setValue(null);
    this.search.emit({} as IntelligenceSearchInterface);
  }

}
